'use client';

import { Maybe } from '@lib/types/Maybe';
import { MicrocopyItem } from '@lib/types/cms/MicrocopySet';
import { PropsWithChildren, createContext, useContext } from 'react';

export const MicrocopyContext = createContext<
  { [key: string]: Maybe<MicrocopyItem[]> } | undefined
>(undefined);

export const MicrocopyProvider = ({
  children,
  value,
}: PropsWithChildren<{
  value?: { [key: string]: Maybe<MicrocopyItem[]> };
}>) => {
  return (
    <MicrocopyContext.Provider value={value}>
      {children}
    </MicrocopyContext.Provider>
  );
};

export const useMicrocopy = <T,>() => {
  const values = useContext(MicrocopyContext);
  return values as T;
};
